export default {
      id: "cog-usage",
      viewBox: "0 0 439 439",
      url: __webpack_public_path__ + "img/icons.b8e1d04b.svg#cog",
      toString: function () {
        return this.url;
      }
    }